(function () {
  function normalize(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  var swatchColors = {
    black: '#111111',
    white: '#ffffff',
    gray: '#9a9a9a',
    grey: '#9a9a9a',
    blue: '#2f62b7',
    navyblue: '#26344f',
    navy: '#26344f',
    brown: '#6d453b',
    heatherbrown: '#6d453b',
    green: '#4f6b55',
    darkgreen: '#314b39',
    pink: '#d989a6',
    red: '#a83b32',
    purple: '#66518a',
    beige: '#d9c7a7',
    orange: '#b75f38',
    rustorange: '#b75f38'
  };

  document.querySelectorAll('[data-swatch-name]').forEach(function (dot) {
    var key = normalize(dot.getAttribute('data-swatch-name'));
    dot.style.setProperty('--swatch-color', swatchColors[key] || '#d8d2ca');
  });

  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var jsonNode = root.querySelector('[data-product-json]');
    var variantSelect = root.querySelector('[data-variant-select]');
    var priceNode = root.querySelector('[data-product-price]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-input]'));
    var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-media-alt]'));
    var product = null;

    try {
      product = JSON.parse(jsonNode.textContent);
    } catch (error) {
      return;
    }

    function selectedOptions() {
      var options = [];
      optionInputs.forEach(function (input) {
        if (input.checked) {
          options[Number(input.getAttribute('data-option-index'))] = input.value;
        }
      });
      return options;
    }

    function findVariant(options) {
      return product.variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === options[index];
        });
      });
    }

    function updateSelectedLabels() {
      optionInputs.forEach(function (input) {
        var labelNode = input.closest('label');
        if (labelNode) labelNode.classList.toggle('is-selected', input.checked);
        if (!input.checked) return;
        var fieldset = input.closest('[data-option-position]');
        var position = fieldset && fieldset.getAttribute('data-option-position');
        var label = root.querySelector('[data-selected-option="' + position + '"]');
        if (label) label.textContent = input.value;
      });
    }

    function updateMedia() {
      var colorInput = root.querySelector('[data-color-input="true"]:checked');
      var selectedColor = colorInput ? normalize(colorInput.value) : '';

      if (!selectedColor || mediaItems.length === 0) {
        mediaItems.forEach(function (item) {
          item.classList.remove('is-hidden');
        });
        return;
      }

      var matches = mediaItems.filter(function (item) {
        return normalize(item.getAttribute('data-media-alt')).indexOf(selectedColor) !== -1;
      });

      if (matches.length === 0) {
        mediaItems.forEach(function (item) {
          item.classList.remove('is-hidden');
        });
        return;
      }

      mediaItems.forEach(function (item) {
        item.classList.toggle('is-hidden', matches.indexOf(item) === -1);
      });
    }

    function updateVariant() {
      var variant = findVariant(selectedOptions());
      updateSelectedLabels();
      updateMedia();

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Unavailable';
        }
        return;
      }

      if (variantSelect) variantSelect.value = variant.id;
      if (priceNode) priceNode.textContent = money(variant.price);

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    updateVariant();
  });
})();
